export default "__VITE_ASSET__CkDsJ4nW__"